import { render, staticRenderFns } from "./ComisionChip.vue?vue&type=template&id=368dfa56&"
import script from "./ComisionChip.vue?vue&type=script&lang=js&"
export * from "./ComisionChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports